import React from "react";
import { InputJson } from "nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import FormFactory from "../../../../components/FormFactory";
import PayrollSetupsFormPresenter from "./ItemOptionsFormPresenter";

class ItemOptionsFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      advanced: false,
      incentive: [],
      deletedObjects: [],
      addedObjects: [],
    };
    this.presenter = new PayrollSetupsFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "item_options";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  deletedObject(value) {
    if (!this.state.deletedObjects.some((obj) => obj.id === value)) {
      this.setState((prevState) => ({
        deletedObjects: [...prevState.deletedObjects, value],
      }));
    }
  }

  addedObject(value) {
    if (!this.state.addedObjects.some((obj) => obj.id === value)) {
      this.setState((prevState) => ({
        addedObjects: [...prevState.addedObjects, value],
      }));
    }
  }

  render() {
    const { object } = this.state;

    console.log("object", object);

    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.save();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson defaultValue={object} rows="15" />
                    ) : (
                      <>
                         <FormFactory
                        schema={schema}
                        object={object}
                        // disabled={true}
                        onChange={this.onChange.bind(this)}
                        deletedObject={this.deletedObject.bind(this)}
                        addedObject={this.addedObject.bind(this)}
                      />
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ItemOptionsFormPage);
